import React from 'react';
import config from '../../../../config';

const AlexaInfo = () => (
    <div>
        Alexa skill: <a href={config.alexaSkillUrl} target="_blank" rel="noopener noreferrer">{config.alexaSkillUrl}</a>
    </div>
);

export default AlexaInfo;
